/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";
import * as Chartist from "chartist";
import util from "../util/util.js";

var SpeciesGraphViewModel = function(params) {
	var self = this;

	// Set default params
	params = _.defaults(params, {
		showSelect: true,
		speciesId: null
	});

	// Share species filter observable globally
	self.speciesFilter = window.speciesFilter || ko.observable(null);
	window.speciesFilter = self.speciesFilter;

	if(params.speciesId) {
		self.speciesFilter({ id: params.speciesId });
	}

	self.speciesFilter.subscribe(function(species) {
		console.log("Species filter changed to: " + species);
	});

	self.species = ko.observable();
	self.loaded = ko.observable(false);

	self.showSelect = ko.pureComputed(function() {
		return self.loaded() && !!params.showSelect;
	});

	self.statsLoading = ko.observable(false);
	self.statsLoaded = ko.observable(true);

	self.insufficientData = ko.observable(false);
	self.description = ko.observable("");

	self.filterCriteria = ko.pureComputed(function() {
		var criteria = {
			permit_stale: true
		};
		if(self.speciesFilter()) {
			criteria.species_id = self.speciesFilter().id;
		}
		return criteria;
	});

	Promise.all([birdata.speciesList()]).then(function([species]) {
		if(params.speciesId) {
			self.speciesFilter(_.findWhere(species, { id: params.speciesId }));
			console.log(self.speciesFilter());
		}

		self.species(
			_.chain(species)
				.filter(function(sp) { return sp.sensitivity_id != 1; })
				.sortBy('common_name')
				.value());

		self.loaded(true);
	});

	var filterToken;
	ko.computed(function() {
		var criteria = self.filterCriteria();
		criteria._options = { public: true };

		var token = filterToken = {};
		self.statsLoaded(false);
		self.statsLoading(true);
		self.description("");

		var chartType = criteria.species_id ? 'reporting_rate_by_year' : 'surveys_by_year';

		birdata.surveyStats(criteria, chartType).then(function(chartData) {
			if(token !== filterToken) return; // Ignore stale request
			updateChart(chartType, chartData);
			self.statsLoaded(true);
		}).finally(function() {
			self.statsLoading(false);
		});
	});

	function updateChart(chartType, chartData) {
		var lineOptions = {
			axisY: {
				//onlyInteger: true,
				labelInterpolationFnc: function(value, index) {
					return util.formatNumber(value);
				},
				low: 0
			},
			axisX: {
				type: Chartist.AutoScaleAxis,
				scaleMinSpace: 30,
				onlyInteger: true
			},
			lineSmooth: Chartist.Interpolation.monotoneCubic(),
			showLine: true,
			showPoint: true
		};
		if(params.height) {
			lineOptions.height = params.height;
		}

		// Limit data to 1998 and onwards
		chartData = chartData.filter(function(x) { return x.year >= 1998 });
		// Set axis range from 1998 to present
		lineOptions.axisX.low = 1998;
		lineOptions.axisX.high = (new Date()).getFullYear();

		var series;
		if(chartType == 'reporting_rate_by_year') {
			series = chartData.map(function(v) {
				return {
					x: v.year,
					y: v.reporting_rate
				};
			});
			self.description("Raw reporting rate (%)");
		} else {
			series = chartData.map(function(v) {
				return {
					x: v.year,
					y: v.count
				}
			});
			self.description("Number of surveys recorded");
		}

		self.insufficientData(series.length == 0);

		setTimeout(function() {
			new Chartist.LineChart('.surveys-vs-year', { series: [series] }, lineOptions);
		});
	}
};


ko.components.register('species-graph', {
	viewModel: function(params) {
		params = params || {};
		return new SpeciesGraphViewModel(params);
	},
	template: require('../../templates/species-graph.html')
});

export default SpeciesGraphViewModel;
